import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@shadcn/ui/card";
import { createFileRoute } from "@tanstack/react-router";
import { Droplet } from "lucide-react";
import ViewmodelWrapper from "@/src/presentation/components/viewmodel-wrapper";
import RegisterViewModel from "@/src/presentation/view-models/register-viewmodel";
import BackToLoginButton from "./_components/back-to-login-button";
import RegisterForm from "./_components/register-form";
import State from "./_components/state";
import Logo from "@/src/presentation/components/logo";

export const Route = createFileRoute("/_public/register/")({
  component: RegisterPage,
});

function RegisterPage() {
  return (
    <ViewmodelWrapper type={RegisterViewModel}>
      <State />
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
        <div className="w-full max-w-md">
          <Logo />

          <Card className="border-brand-accent-subtle shadow-lg">
            <CardHeader className="space-y-1">
              <CardTitle className="text-center text-2xl font-bold">Register Account</CardTitle>
              <CardDescription className="text-center">
                Create a new account to use the water device management system
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-col gap-y-4">
                <RegisterForm />
              </div>
            </CardContent>
            <CardFooter className="flex flex-col gap-y-4">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <span className="w-full border-t" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-card text-muted-foreground px-2">Or</span>
                </div>
              </div>
              <BackToLoginButton />
            </CardFooter>
          </Card>
        </div>
      </div>
    </ViewmodelWrapper>
  );
}
